import styled from 'styled-components'

export const CarouselSection = styled.section`
  width: 100%;
  height: 253px;
  background: var(--grey5, #f3f5f9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    height: auto;
    padding-bottom: 40px;
  }
`

export const Title = styled.h2`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  margin-bottom: 11px;
  color: var(--blue6, #21105d);

  @media (max-width: 768px) {
    font-size: 20px;
    margin-top: 30px;
    padding: 0 20px;
  }

  span.number {
    color: #5039dd;
  }
`

export const LogoSlider = styled.div`
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 120px;

  @media (max-width: 768px) {
    min-height: 80px;
  }

  .slick-track {
    display: flex;
    align-items: center;
  }

  .slick-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 120px;
    padding: 0 30px;

    @media (max-width: 768px) {
      height: 80px;
      padding: 0 20px;
    }

    & > div {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;

      & > div {
        display: flex !important;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
      }
    }
  }

  img {
    max-height: 80px;
    max-width: 150px;
    width: auto;
    height: auto;
    object-fit: contain;
    filter: none;
    margin: 0 auto;

    @media (max-width: 768px) {
      max-height: 35px;
      max-width: 80px;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`
